import { render, staticRenderFns } from "./CustomAuthContainer.vue?vue&type=template&id=726dcfce&"
var script = {}
import style0 from "./CustomAuthContainer.vue?vue&type=style&index=0&id=726dcfce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports